import Consts from '../Const'
import { Unauthorized } from '../Errors/Unauthorized'
import { AppType, mapAppTypeToServerAppType } from './ServiceTypes'

interface Credentials {
  username: string
  password: string
}

export enum IAppPlatform {
  Other = 0,
  Android = 1,
  iOS = 2,
}

export interface IPushToken {
  Id: string
  PlayerId: string
  Token: string
  Platform: IAppPlatform
  Timestamp: string | Date //e.g. /Date(1625646966367+0200)/
}

export interface IPlayer {
  Id: string
  Admin: boolean
  AvatarId: string | null
  Deleted: boolean
  Email: string
  Fullname: string
  Username: string
  Organization_Admin: boolean
  Organization_Active: boolean
  FirstTimeLoggedIn: string | Date | null | undefined
  ChangePasswordOnLogon: boolean | null | undefined
}

export interface IPlayerExtendedInfo {
  Player: IPlayer
  PushTokens: IPushToken[]
}

export interface ILoginCookieInfo {
  AppType: string
  AuthorizationToken: string
  AuthorizationDeviceId: string
}

function trimSpacesAndQuotes(value: string): string {
  return value.trim().replace(/^["'“”‘’]+|["'“”‘’]+$/g, '')
}

export default class ServiceSecurity {
  static async fetchToken(credentials: Credentials, appType: AppType) {
    const base64 = require('base-64')
    const username = credentials.username.trim()
    const password = credentials.password
    const credentialsDecoded = username + ':' + password
    const credentialsEncoded = base64.encode(credentialsDecoded)
    const requestUrl = 'security/fetchToken'

    return await fetch(`${Consts.defaultBaseUrl}/${requestUrl}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Basic ' + credentialsEncoded,
        AuthorizationDeviceId: 'Editor',
        AppType: `${mapAppTypeToServerAppType(appType)}`,
      },
    })
      .then(res => {
        // if (res.status !== 200) {
        //   throw new Error()
        // }

        const json = res.text()
        return new Promise<{ status: number; data: string }>((resolve, reject) => {
          json
            .then(x => {
              console.log(`x var lig med... ¤${x}¤`)
              resolve({
                status: res.status,
                data: trimSpacesAndQuotes(x as string),
              })
            })
            .catch(reject)
        })
      })
      .then(response => {
        if (response.status !== 200) {
          throw new Error(response.data)
        }
        return response.data
      })
  }

  static async fetchLoginCookieInfo(): Promise<ILoginCookieInfo | undefined> {
    const requestUrl = 'security/fetchLoginCookieInfo?useCookie=true'
    return await fetch(`${Consts.defaultBaseUrl}/${requestUrl}`, {
      method: 'GET',
      credentials: Consts.isOtherDomainThanAPI ? undefined : 'include',
    })
      .then(res => {
        if (res.status !== 200) {
          return undefined
        }

        const json = res.json()
        return json
      })
      .then(responseJson => {
        return responseJson as ILoginCookieInfo
      })
  }

  static async fetchPlayerExtendedInfo(token: string, appType: AppType): Promise<IPlayerExtendedInfo> {
    const requestUrl = 'security/fetchPlayerExtendedInfo'
    return await fetch(`${Consts.defaultBaseUrl}/${requestUrl}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        AuthorizationDeviceId: 'Editor',
        AuthorizationToken: token,
        AppType: `${mapAppTypeToServerAppType(appType)}`,
      },
      credentials: Consts.isOtherDomainThanAPI ? undefined : 'include',
    })
      .then(res => {
        if (res.status !== 200) {
          if (res.status === 401) {
            throw new Unauthorized()
          }
          throw new Error('Error')
        }

        const json = res.json()
        return json
      })
      .then(responseJson => {
        return responseJson as IPlayerExtendedInfo
      })
  }

  static async logout(token: string, appType: AppType): Promise<void> {
    const requestUrl = 'security/logout'
    return await fetch(`${Consts.defaultBaseUrl}/${requestUrl}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        AuthorizationDeviceId: 'Editor',
        AuthorizationToken: token,
        AppType: `${mapAppTypeToServerAppType(appType)}`,
      },
      credentials: Consts.isOtherDomainThanAPI ? undefined : 'include',
    }).then(res => {
      if (res.status !== 200) {
        if (res.status === 401) {
          throw new Unauthorized()
        }
        throw new Error('Error')
      }
    })
  }
}
